<template>
    <section class="py-20 bg-white">
        <div class="max-w-[1200px] mx-auto px-4">
            <h2 class="text-[28px] md:text-4xl lg:text-5xl font-bold text-center mb-12">Unsere <span class="text-[#006CFF]">Marktanalysen</span> im Überblick</h2>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div v-for="(market, index) in markets" :key="index" class="rounded-2xl p-8 flex flex-col items-center gap-0 text-white justify-between" :class="market.bgClass">
                    <img :src="market.image" class="h-[120px]" />
                    <h3 class="text-2xl font-bold text-center">{{ market.title }}</h3>
                    <p class="text-center text-lg my-8">{{ market.description }}</p>
                    <router-link :to="market.link" class="bg-white text-[#006CFF] px-6 py-4 rounded-full font-semibold transition hover:opacity-90 inline-flex items-center gap-2">
                        {{ market.ctaText }}
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    markets: {
        type: Array,
        default: () => []
    }
});
</script>
